import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CBWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-529">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-530">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-531">
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-532">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-533">
              <img src="https://cdn.magicpatterns.com/uploads/m9DVUxtVtr4gsSfjNMVk3A/AdobeStock_257206406-5.jpg" alt="Be CLINICAL Clear + Brilliant Specialist" className="w-full h-full object-cover" data-id="element-534" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-535">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-536">
              WHY CHOOSE BE CLINICAL FOR CLEAR + BRILLIANT TOUCH
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-537"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-538">
              <p data-id="element-539">
                When choosing a provider for Clear + Brilliant Touch, selecting
                Be CLINICAL guarantees a journey defined by expertise,
                innovation and individualized attention. Our unwavering
                commitment to excellence permeates every facet of our practice,
                from your initial consultation to the culmination of your
                transformative experience. At Be CLINICAL, we prioritize your
                unique aesthetic objectives and concerns, tailoring treatment
                strategies that harness the latest advancements in laser
                technology, including the Clear + Brilliant Touch Laser.
              </p>
              <p data-id="element-540">
                Led by a team of highly adept professionals renowned for their
                proficiency in laser skin resurfacing, each Clear + Brilliant
                Touch session at Be CLINICAL is meticulously administered to
                yield optimal outcomes. With a steadfast focus on safety,
                efficacy, and patient satisfaction, Be CLINICAL stands as a
                paragon of quality in the realm of cosmetic rejuvenation. If you
                are ready to embark on a journey to revitalize your skin with
                confidence and precision, request your complimentary
                consultation today!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-541">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}